<template>
  <div class="monitor">
    <p>Enter the number to call back to:</p>
    <input
      type="text"
      :class="{ required: required }"
      style="padding: 10px 15px"
      v-model="extension"
    />

    <div class="flex-full coach">
      <input type="checkbox" v-model="coach" />
      <p>Coach Agent?</p>
    </div>

    <p>
      Please note if you tick 'Coach Agent', only the agent would hear your
      voice.
    </p>
    <div class="flex-full btns">
      <input
        type="button"
        value="Connect"
        class="connect btn"
        @click="connectListener"
      />
      <input
        type="button"
        value="Cancel"
        class="cancel btn"
        @click="$emit('close')"
      />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      extension: "",
      coach: false,
      required: false,
    };
  },
  computed: {
    agentCampaign() {
      return this.$store.getters.monitoringAgent.campaign;
    },
  },
  methods: {
    connectListener() {
      if (!this.extension) {
        this.required = true;
        return;
      }
      
      this.$diamond
        .connectListener(this.extension, this.agentCampaign, this.coach)
        .then(() => {
          this.$store.commit("setExtension", this.extension)
          this.$emit("close");
        });
    },
  },
};
</script>

<style>
.required {
  border-color: red !important;
}

.monitor {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  background-color: white;
  top: 0;
  padding: 5% 10%;
  box-sizing: border-box;
  z-index:2;
}

.coach {
  width: 20%;
  min-width: 0px !important;
}

.btns {
  width: 30%;
  min-width: 0px !important;
}

.connect {
  background-color: #6ab025;
  border-color: #6ab025;
}

.cancel {
  background-color: #ea4444;
  border-color: #ea4444;
}

.btn {
  box-shadow: 0 1px 3px rgb(0 0 0 / 7%);
  border-width: 1px;
  border-style: solid;
  padding: 7px 18px 8px;
  color: #ffffff;
  font-weight: normal;
  font-size: 13px;
  line-height: normal;
  display: inline-block;
  cursor: pointer;
  text-align: center;
  vertical-align: middle;
  max-width: 100%;
  border-radius: 3px;
  min-width: 100px;
  height: 35px;
}
</style>